import "./text-area.css";
import { TextArea } from './text-area';
export default TextArea;